import { Navigate, Outlet } from "react-router";
import { isAuthenticated } from "@/store/auth-store";

interface PublicRouteProps {
  redirectPath?: string;
}

export const PublicRoute = ({ redirectPath = "/" }: PublicRouteProps) => {
  // If user is authenticated, redirect to the specified path, else render child routes
  return isAuthenticated() ? (
    <Navigate to={redirectPath} replace />
  ) : (
    <Outlet />
  );
};
